export default __webpack_public_path__ + "static/4tellAI_dashboard-83c6b3f9ad5043dbc80073ca2dd0f817.png";